import { T } from 'gt-react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { useCanViewFeedbackPage } from '@/hooks/useCanViewFeedbackPage';
import paths from '@/paths';

/** Top-nav entry for the feedback page. */
export function FeedbackNavLink() {
  const canView = useCanViewFeedbackPage();
  if (!canView) return null;

  return (
    <Button variant="ghost" size="sm" asChild>
      <Link to={paths.authenticated.feedbackTriage}>
        <T context="top navbar feedback link label">Feedback</T>
      </Link>
    </Button>
  );
}
